<div class="row" id="wizardJobDescription">
  <!-- Itinerary of service head start portion -->
    <div class="col-12 pt-3 mb-3">
      <div class="row">
        <div class="col-12 p-0">
          <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
        </div>
      </div>
    </div> 
  <!-- Itinerary of service head end portion -->
  <!-- Itinerary of service head content start portion -->
    <div class="col-12 contentPortion pt-0" *ngIf="isDataLoaded">
      <lib-itinerary-of-services-library [primaryData]="inputData" style="width:100%" [isWizard]="true">
      </lib-itinerary-of-services-library>
    </div>
  <!-- Itinerary of service head content end portion -->
</div>